import axios from "axios";
import Links from "@/shared/constants/Links";

const CbtCourse = {
    /**
     * Add a course to the CBT list for a semester
     * @param {number} courseId
     * @param {number} semesterId
     * @param {'CA'|'EXAM'|'BOTH'} assessmentType
     * @returns {Promise<AxiosResponse<any>>}
     */
    add: async (courseId, semesterId, assessmentType) => {
        return axios.post(Links.cbtCourse.add, {
            courseId: courseId,
            semesterId: semesterId,
            assessmentType: assessmentType
        });
    },

    updateAssessmentType: async (id, assessmentType) => {
        return axios.put(`${Links.cbtCourse.updateAssessmentType}${id}/assessment-type`, { assessmentType });
    },

    /**
     * Remove a CBT course record
     * @param {number} id CBT course record ID
     * @returns {Promise<AxiosResponse<any>>}
     */
    remove: async (id) => {
        return axios.delete(Links.cbtCourse.remove + id);
    },

    /**
     * List CBT courses by semester (paginated)
     * @param {number} semesterId
     * @param {number} page 0-based
     * @param {number} size
     * @returns {Promise<AxiosResponse<any>>}
     */
    all: async (semesterId, page, size) => {
        return axios.get(Links.cbtCourse.all + `?semester=${semesterId}&page=${page}&size=${size}`);
    },

    /**
     * Get a single CBT course by ID
     * @param {number} id
     * @returns {Promise<AxiosResponse<any>>}
     */
    getById: async (id) => {
        return axios.get(Links.cbtCourse.getById + id);
    },
};

export default CbtCourse;
